module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("默认背景色gray")]), _vm._v(" "), _c('mt-layout-container', {
    attrs: {
      "background": "gray",
      "padding": "30px",
      "margin": "10px"
    }
  }, [_vm._v("margin (10px)+padding(30px)")]), _vm._v(" "), _c('mt-layout-container', {
    staticClass: "layout-container",
    attrs: {
      "background": "#52C7CA",
      "margin": "10px"
    }
  }, [_vm._v("\n    Hello World!!!\n    "), _c('mt-subscript', {
    attrs: {
      "label": "成功",
      "fontsize": "12px",
      "background": "red",
      "width": "90px",
      "height": "16px",
      "rotate": "45"
    }
  })], 1), _vm._v(" "), _c('mt-layout-container', {
    attrs: {
      "margin": "10px"
    }
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("按钮1")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("按钮2")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41a9a831","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/layout-container.vue
// module id = 554
// module chunks = 0